import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const SummaryView = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.summary-view.title"
                    defaultMessage="Summary view"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.summary-view.bodyOne"
                    defaultMessage="Summary view gives you an overall snapshot of your team’s work, including status overviews, workloads, and more."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.summary-view.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about summary view."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={`https://support.atlassian.com${useLocalizedHref(
                                    "/jira-work-management/docs/get-a-summary-of-your-project/"
                                )}`}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default SummaryView;
